import React from 'react';
import './App.css';
import Navbar from './components/navbar';
import Hero from './components/hero';
import Features from './components/features';
import Footer from './components/footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import PortfolioBuilder from './pages/PortfolioBuilder';
import PublicPortfolio from './pages/PublicPortfolio';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <Navbar />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <Features />
              </>
            } />
            <Route path="/builder" element={<PortfolioBuilder />} />
            <Route path="/view" element={<PublicPortfolio />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}


export default App;
